import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IDesignObjectData } from '../../../interface/design-object-data.interface';

export const updateActiveDesignObjectSettings = (payload: any) => returnAction<IDesignObjectData>(ActionEnum.UPDATE_ACTIVE_DESIGN_OBJECT_SETTINGS, payload, true);
